var _excluded = ["isViewMode", "viewModePlaceholder", "deleteButtonText", "value", "onChange", "isLoading", "acceptTypes", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRef, useState } from 'react';
import { Loader } from '../../../foundations/Loader';
import { forwardRef, useBoolean, useUpdateEffect } from '../../../utils';
import { getInputFileAcceptByType } from '../../../utils/get-input-file-accept';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { IconButton, NakedButton } from '../../action';
import { getAvatarInitials } from '../../dataDisplay/Avatar/avatar.utils';
import { Blanket } from '../../feedback';
import { Box } from '../../internal';
import { Image } from '../../media';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AvatarImageControl = forwardRef((_ref, ref) => {
  var {
    isViewMode,
    viewModePlaceholder,
    deleteButtonText,
    value,
    onChange,
    isLoading,
    acceptTypes,
    variant = 'circle'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [isHover, setIsHover] = useBoolean(false);
  var styles = useMultiStyleConfig('AvatarImageControl', {
    isViewMode,
    isLoading,
    variant
  });
  var [selectedFileUrl, setSelectedFileUrl] = useState(value !== null && value !== void 0 ? value : '');
  var hiddenFileInputRef = useRef(null);
  useUpdateEffect(() => {
    value && setSelectedFileUrl(value);
  }, [value]);

  var handleClick = () => {
    var _hiddenFileInputRef$c;

    if (isViewMode || isLoading) return;
    (_hiddenFileInputRef$c = hiddenFileInputRef.current) === null || _hiddenFileInputRef$c === void 0 ? void 0 : _hiddenFileInputRef$c.click();
  };

  var handleChange = _ref2 => {
    var {
      target: {
        files
      }
    } = _ref2;

    if (files !== null && files !== void 0 && files[0]) {
      setSelectedFileUrl(URL.createObjectURL(files[0]));
      onChange === null || onChange === void 0 ? void 0 : onChange(files[0]);
    }
  };

  var handleDelete = event => {
    event.stopPropagation(); // clear input so same file can be chosen again (if user wants)

    if (hiddenFileInputRef.current) {
      hiddenFileInputRef.current.value = '';
    }

    setSelectedFileUrl('');
    onChange === null || onChange === void 0 ? void 0 : onChange(null);
  };

  var showImage = !!selectedFileUrl;
  var showIcon = !isViewMode && !isLoading;
  var showInitials = isViewMode && !selectedFileUrl;
  var showDeleteButton = !isViewMode && selectedFileUrl;
  var showImageMask = !isViewMode;
  var showLoader = isLoading && !isViewMode; // don't show loader if `isReadyOnly` to avoid strange state (though we shouldn't reach this state at all)

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-component": "AvatarImageControl"
  }, props), {}, {
    ref: ref,
    __css: styles['container'],
    onMouseOver: setIsHover.on,
    onMouseOut: setIsHover.off,
    children: [/*#__PURE__*/_jsxs(Box, {
      __css: styles['avatar'],
      onClick: handleClick,
      children: [showIcon && /*#__PURE__*/_jsx(Box, {
        __css: styles['icon'],
        children: /*#__PURE__*/_jsx(IconButton, {
          icon: "image-add",
          variant: "nakedInverted",
          "aria-label": "Add Image",
          "data-hover": isHover || null
        })
      }), showImage && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Blanket, {
          isOpen: showImageMask,
          isLoading: showLoader
        }), /*#__PURE__*/_jsx(Box, {
          __css: styles['image'],
          children: /*#__PURE__*/_jsx(Image, {
            alt: "avatar image",
            src: selectedFileUrl
          })
        })]
      }), showLoader && /*#__PURE__*/_jsx(Loader, {
        "data-testid": "loader",
        color: "neutral.white"
      }), showInitials && /*#__PURE__*/_jsx(Box, {
        __css: styles['initials'],
        "data-testid": "avatar-initials",
        children: getAvatarInitials(viewModePlaceholder)
      }), /*#__PURE__*/_jsx(Box, {
        as: "input" // ts-ignore is used due to `type` issues with `<Box/>`.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        ,
        type: "file",
        "aria-label": "upload image",
        "data-testid": "upload-image-input",
        accept: getInputFileAcceptByType(acceptTypes),
        ref: hiddenFileInputRef,
        style: {
          display: 'none'
        },
        onChange: handleChange
      })]
    }), showDeleteButton && /*#__PURE__*/_jsx(NakedButton, {
      "data-testid": "delete-image",
      isDisabled: isLoading,
      variant: "critical",
      size: "small",
      onClick: handleDelete,
      label: deleteButtonText
    })]
  }));
});
AvatarImageControl.displayName = 'AvatarImageControl';
//# sourceMappingURL=AvatarImageControl.js.map